<template>
    <div>
        <div class="container">
            <container :active_path="path" :plate="plate">
                <div class="base-warp">
                    <div class="head">
                        <div class="title">小程序首页弹窗设置，点击编辑添加广告图链接，拖动排序,修改完记得点
                        <el-button class="sav-btn" type="primary" size="mini" @click="confirm">保存</el-button>
                    </div>
                    </div>
                    <div class="table-box">
                        <div class="file-warp">
                            <div class="img-warp">
                                <transition-group name="flip-list" tag="div">
                                    <div class="img-box" draggable="true" v-for="(img, ind) in imgs" :key="ind" @dragstart="dranstart(img)" @dragend="dragend" @dragenter="dragenter(img)">
                                        <el-button class="del-btn" type="danger" size="mini" icon="el-icon-delete" circle @click.stop="delimg(img, ind)"></el-button>
                                        <el-popover
                                            placement="bottom"
                                            title="选择链接位置"
                                            width="400"
                                            trigger="click">
                                            <el-select v-model="img.url" value-key="" size="mini" placeholder="请选择" clearable filterable>
                                                <el-option v-for="(item, index) in paths"
                                                    :key="index"
                                                    :label="item.label"
                                                    :value="item.url">
                                                </el-option>
                                            </el-select>

                                            <div 
                                            class="hit-box" 
                                            v-if="img.url.indexOf('=')>-1">
                                                <p>请输入id</p>
                                                <el-input v-model="img.vid" placeholder="" size="mini" clearable></el-input>
                                            </div>
                                            
                                            <el-button slot="reference" class="edit-btn" type="primary" size="mini" icon="el-icon-edit-outline" circle @click.stop="editurl(img, ind)"></el-button>
                                        </el-popover>
                                        
                                        <el-image class="img" :src="img.path" fit="scale-down" :lazy="true"></el-image>
                                    </div>
                                </transition-group>
                            </div>
                        </div>
                        <div class="upl-warp">
                            <el-upload
                                class="upload-demo"
                                drag
                                action="/api/Upload/uploadFile/"
                                :on-success="handleUploadSuccess"
                                :before-upload="beforeUpload"
                                multiple>
                                <i class="el-icon-upload"></i>
                                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                                <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过1M</div>
                            </el-upload>
                            <el-button class="sav-btn" type="primary" size="default" @click="confirm">保存</el-button>
                        </div>
                    </div>
                </div>
            </container>
        </div>
    </div>
</template>

<script>
import Container from '../../components/container';
export default {
    components: {
        Container
    },
    data() {
        return {
           plate: '真会投资',
            path: '/applet/question-advertising',
            tutorurl: 'https://applet.hangehouse.com/#/tutor/index',
            brokerurl: 'https://applet.hangehouse.com/#/attract/house/list',
            consultanturl: 'https://applet.hangehouse.com/#/consultant/index',
            imgs: [],
            oldNum: 0,
            newNum: 0,
                        paths: [
                {
                    label: '投资军团',
                    url: '/pages/home/invest2/invest2',
                },
                {
                    label: '活动详情',
                    url: '/packages/pages/activity/detail/detail?id=',
                    id: '',
                },
                {
                    label: '问专家首页',
                    url: '/packages/pages/question/list/list',
                },
                {
                    label: '问专家详情',
                    url: '/packages/pages/question/detail/detail?qid=',
                    id: '',
                },
                {
                    label: '投资资讯首页',
                    url: '/pages/home/news/news',
                },
                {
                    label: '投资资讯详情页',
                    url: '/packages/pages/information/article/article?id=',
                    id: '',
                },
                {
                    label: '楼盘详情页',
                    url: '/packages/pages/house/info/info?house_id=',
                    id: '',
                },
                {
                    label: '招商项目或房源',
                    url: '/packages/pages/attract/detail/detail?id=',
                    id: '',
                },
                {
                    label: '导师专属页面',
                    url: '/pages/home/tutor/tutor?id=',
                    id: '',
                },
                {
                    label: '置业顾问中心',
                    url: '/pages/home/webview/webview?url=https://applet.hangehouse.com/#/consultant/index&title=置业顾问中心',
                    id: '',
                },
                {
                    label: '经纪人中心',
                    url: '/pages/home/webview/webview?url=https://applet.hangehouse.com/#/attract/house/list&title=房源管理',
                    id: '',
                },
                {
                    label: '导师中心',
                    url: '/pages/home/webview/webview?url=https://applet.hangehouse.com/#/tutor/index&title=导师中心',
                },
                {
                    label: '我要卖房',
                    url: '/packages/pages/sell/house-list/house-list',
                },
                {
                    label: '帮我找房',
                    url: '/pages/home/looking-for-a-room/looking-for-a-room',
                },
                {
                    label: '公寓节',
                    url: '/pages/home/webview/webview?url=https://applet.hangehouse.com/#/activity/apartment&title=公寓节',
                }
            ],
            pathId: '',
            showPathId: false,
        }
    },
    mounted () {
        this.getData();
    },
    methods: {
        getData() {
            var params = {
                type: 'question-advertising',
            };
            this.$api.getAppletHomeBanner(params).then(
                data=>{
                    if (data){
                        this.imgs = JSON.parse(data.banner);
                    }
                }
            )
        },
        confirm() {
            var params = {
                banners: JSON.stringify(this.imgs),
                type: 'question-advertising',
            }
            this.$api.setAppletHomeBanner(params).then(
                data=>{
                    this.$message.success(data);
                }
            )
        },
        dranstart(value) {
            this.oldNum = value;
        },
        dragend: function(value) {
            if (this.oldNum != this.newNum) {
                let oldIndex = this.imgs.indexOf(this.oldNum);
                let newIndex = this.imgs.indexOf(this.newNum);
                let newItems = [...this.imgs];
                // 删除老的节点
                newItems.splice(oldIndex, 1); 
                // 在列表中目标位置增加新的节点
                newItems.splice(newIndex, 0, this.oldNum);
                // this.items一改变，transition-group就起了作用
                this.imgs = [...newItems];
            }
        },
        dragenter: function(value) {
            this.newNum = value;
        },
        editurl(img, index) {

        },
        delimg(img, index) {
            this.$confirm("是否确定删除").then(
                confirm=>{
                    this.imgs.splice(index, 1);
                },
                cancel=>{}
            )
        },
        handleUploadSuccess(res) {
            let {data, errCode, msg} = res;
            if (data){
                this.$message.success(msg);
                var obj = {
                    vid: '',
                    url: '',
                    path: data,
                }
                this.imgs.push(obj);
            } else {
                this.$message.error(msg);
            }
        },
        beforeUpload(file) {
            const isJPG = file.type === 'image/jpeg';
            const isPNG  = file.type === 'image/png';
            // const isLt2M = file.size / 1024 / 1024 < 1;
            if (!isJPG&&!isPNG) {
                this.$message.error('只能上传图片，不能上传其他文件!');
            }
            // if (!isLt2M) {
            //     this.$message.error('上传的图片大小不能超过 1MB!');
            // }

            return isJPG||isPNG;
        },
    },
}
</script>

<style lang="scss" scoped>
.head{
    .title{
        line-height: 28px;
    }
}
.table-box{
    margin-top: 10px;
}
.file-warp{
    margin-bottom: 4px;
    min-height: 158px;
    border-bottom: 1px dashed #eee;
    .img-warp{
        width: 100%;
        overflow: hidden;
        .img-box{
            width: 233px;
            height: 160px;
            border: 1px dashed #eee;
            float: left;
            box-sizing: border-box;
            margin-right: 10px;
            margin-bottom: 10px;
            position: relative;
            .del-btn{
                position: absolute;
                top: 0;
                right: 0;
                z-index: 10;
            }
            .edit-btn{
                position: absolute;
                top: 36px;
                right: 0;
                z-index: 10;
            }
            .img{
                width: 230px;
                height: 158px;
                vertical-align: middle;
            }
        }
    }
}
.upl-warp{
    margin-top: 10px;
    position: relative;
    .sav-btn{
        position: absolute;
        left: 400px;
        top: 10px;
    }
}
</style>